import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { FaCheckCircle, FaCircleNotch, FaClock, FaCubes, FaMinusCircle } from 'react-icons/fa';

const OPTIONS = [
  { value: '',              label: 'All material statuses', Icon: FaCubes,       color: '#64748b' },
  { value: 'not_requested', label: 'Not requested',         Icon: FaMinusCircle, color: '#94a3b8' },
  { value: 'requested',     label: 'Requested',             Icon: FaClock,       color: '#d97706' },
  { value: 'in_progress',   label: 'Partially released',    Icon: FaCircleNotch, color: '#2563eb' },
  { value: 'completed',     label: 'Released',              Icon: FaCheckCircle, color: '#16a34a' },
];

const OptionLabel = ({ Icon, color, label }) => (
  <span className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-font-medium tw-text-slate-700">
    <Icon size={12} style={{ color }} className="tw-shrink-0" />
    <span>{label}</span>
  </span>
);

OptionLabel.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

const MaterialStatusSelect = ({ value, onChange, width = 190 }) => (
  <Select
    inputId="material-status-filter"
    aria-label="Material Status"
    isSearchable={false}
    options={OPTIONS}
    value={OPTIONS.find((option) => option.value === value) || OPTIONS[0]}
    onChange={(option) => onChange(option?.value || '')}
    formatOptionLabel={(option) => <OptionLabel {...option} />}
    menuPortalTarget={document.body}
    menuPosition="fixed"
    styles={{
      control: (base, state) => ({
        ...base,
        width,
        minHeight: 36,
        height: 36,
        borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
        boxShadow: state.isFocused ? '0 0 0 1px #c7d2fe' : 'none',
        '&:hover': { borderColor: '#6366f1' },
      }),
      valueContainer: (base) => ({ ...base, height: 34, padding: '0 10px' }),
      indicatorsContainer: (base) => ({ ...base, height: 34 }),
      dropdownIndicator: (base) => ({ ...base, padding: 6, color: '#64748b' }),
      indicatorSeparator: () => ({ display: 'none' }),
      menu: (base) => ({ ...base, zIndex: 1100, overflow: 'hidden' }),
      menuPortal: (base) => ({ ...base, zIndex: 1100 }),
      option: (base, state) => ({
        ...base,
        padding: '8px 10px',
        backgroundColor: state.isSelected ? '#eef2ff' : state.isFocused ? '#f8fafc' : '#fff',
      }),
    }}
  />
);

MaterialStatusSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default MaterialStatusSelect;
